import { Action } from '@ngrx/store';

import {
  SearchCoordinatesPayload, SearchFromCoordinatesErrorPayload, GridSelectLayerPayload,
  KvSection, RenewArcGisTokenPayload, ToolboxMailMergePayload, SearchPayload,
  ToolboxMailMergeOptions, UserProfile
} from './application.state';

import { DnvMarker, DnvLatLng, DnvMapInfo, UserNotification, DnvBounds, PropertyInfo } from 'dnv-lib';
import { SearchedInfo } from 'src/app/models/search-info';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Params } from '@angular/router';

export const ApplicationActionType = {
  Search: '[application] Search',
  SearchSuccess: '[application] SearchSuccess',
  SearchError: '[application] SearchError',
  SearchReset: '[application] SearchReset',
  DelayedAction: '[application] DelayedAction',
  DelayedActionBy1: '[application] DelayedActionBy1',
  Error: '[application] Error',
  // Live: '[application] Live',
  Legend: '[application] Legend',
  Layer: '[application] Layer',
  Toolbox: '[application] Toolbox',
  Draw: '[application] Draw',
  Measure: '[application] Measure',
  Table: '[application] Table',
  Idle: '[application] Idle',
  GetLayers: '[application] GetLayers',
  CheckLayerDisplay: '[application] CheckLayerDisplay',
  SetSearchCoordinates: '[application] SetSearchCoordinates',
  SearchCoordinates: '[application] SearchCoordinates',
  SearchCoordinatesSuccess: '[application] SearchCoordinatesSuccess',
  SearchCoordinatesError: '[application] SearchCoordinatesError',
  SearchFromCoordinates: '[application] SearchFromCoordinates',
  SearchFromCoordinatesSuccess: '[application] SearchFromCoordinatesSuccess',
  SearchFromCoordinatesError: '[application] SearchFromCoordinatesError',
  GetShape: '[application] GetShape',
  GetDBLink: '[application] GetDBLink',
  GridSelectLayer: '[application] GridSelectLayer',
  GetGridSelectLayerSuccess: '[application] GetGridSelectLayerSuccess',
  GetGridSelectLayerError: '[application] GetGridSelectLayerError',
  InvalidateGridCache: '[application] InvalidateGridCache',
  SetGridRasterHighlight: '[application] SetGridRasterHighlight',
  UpdateWindowSize: '[application] UpdateWindowSize',
  GetBasemaps: '[application] GetBasemaps',
  GetMetaData: '[application] GetMetaData',
  GetDataNames: '[application] GetDataNames',
  ToastUserNotification: '[application] ToastUserNotification',
  IdentifySurroundingFeature: '[application] IdentifySurroundingFeature',
  IdentifySurroundingFeaturePost: '[application] IdentifySurroundingFeaturePost',
  GetFeatureData: '[application] GetFeatureData',
  SetSurroundingFeature: '[application] SetSurroundingFeature',
  SetSelectedFeatureSections: '[application] SetSelectedFeatureSections',
  ConcatSelectedFeatureSections: '[application] ConcatSelectedFeatureSections',
  Export: '[application] Export',
  // EngDraw: '[application] Engineering Drawing',
  // SvcConn: '[application] Service Connections',
  AppMapViewLoadFinished: '[application] AppMapViewLoadFinished',
  SearchEngineerDrawings: '[application] SearchEngineerDrawings',
  SearchEngineerDrawingsByNum: '[application] SearchEngineerDrawingsByNum',
  SearchEngineerDrawingsByProj: '[application] SearchEngineerDrawingsByProj',
  SearchEngineerDrawingsByNumType: '[application] SearchEngineerDrawingsByNumType',
  GetEngDrawingGeometry: '[application] GetEngDrawingGeometry',
  OpenEngDrawing: '[application] OpenEngDrawing',
  OpenMapView: '[application] OpenMapView',
  RenewArcGisToken: '[application] RenewArcGisToken',
  RenewArcGisTokenSuccess: '[application] RenewArcGisTokenSuccess',
  RenewArcGisTokenError: '[application] RenewArcGisTokenError',
  // CCTV: '[application] CCTV',
  SearchCCTV: '[application] SearchCCTV',
  SetCCTV: '[application] SetCCTV',
  SelectCCTV: '[application] SelectCCTV',
  SearchCCTVNotes: '[application] SearchCCTVNotes',
  SetCCTVNotes: '[application] SetCCTVNotes',
  // PropInfo: '[application] PropertyInfo'
  SetToolboxStatus: '[application] SetToolboxStatus',
  GetMailMergeByProperty: '[application] GetMailMergeByProperty',
  GetMailMergeByArea: '[application] GetMailMergeByArea',
  GetMailMergeList: '[application] GetMailMergeList',
  ToolboxMailMerge: '[application] ToolboxMailMerge',
  ToolboxMailMergeArea: '[application] ToolboxMailMergeArea',
  ToolboxMailMergeBuffer: '[application] ToolboxMailMergeBuffer',
  ToolboxMailMergeSelectedParcels: '[application] ToolboxMailMergeSelectedParcels',
  ToolboxMailMergeToggleParcelAtCoordinate: '[application] ToolboxMailMergeToggleParcelAtCoordinate',
  ToolboxMailMergeToggleParcel: '[application] ToolboxMailMergeToggleParcel',
  ToolboxMailMergeUpdateOptions: '[application] ToolboxMailMergeUpdateOptions',
  ToolboxMailMergeUpdateResultCount: '[application] ToolboxMailMergeUpdateResultCount',
  ToolboxMailMergeUpdateResultCountSuccess: '[application] ToolboxMailMergeUpdateResultCountSuccess',
  RefreshDisplayedGeoJson: '[application] RefreshDisplayedGeoJson',
  SetMailMergeList: '[application] SetMailMergeList',
  SetMailMergeDBLinks: '[application] SetMailMergeDBLinks',
  LaunchStreetView: '[application] LaunchStreetView',
  ToggleStreetView: '[application] ToggleStreetView',
  SetMeasurements: '[application] SetMeasurements',
  SetFeatureRasterHighlight: '[application] SetFeatureRasterHighlight',
  GetCoordsByObjectId: '[application] GetCoordsByObjectId',
  SetEditFeature: '[application] SetEditFeature',
  GetEditPermission: '[application] GetEditPermission',
  SetEditPermission: '[application] SetEditPermission',
  SetNewFeatureLatLng: '[application] SetNewFeatureLatLng',
  SetLastEditFeature: '[application] SetLastEditFeature',
  SaveEditFeature: '[application] SaveEditFeature',
  UpdateEditFeature: '[application] UpdateEditFeature',
  DeleteEditFeature: '[application] DeleteEditFeature',
  GetMaxAssetId: '[application] GetMaxAssetId',
  GetMaxAssetIdError: '[application] GetMaxAssetIdError',
  SetMaxAssetId: '[application] SetMaxAssetId',
  UpdateEditFeatureGeometry: '[application] UpdateEditFeatureGeometry',
  SetShowSpinner: '[application] SetShowSpinner',
  SetShowSearchSpinner: '[application] SetShowSearchSpinner',
  SetUserProfile: '[application] SetUserProfile',
  GetSnapGeometry: '[application] GetSnapGeometry',
  GetSnapGeometrySuccess: '[application] GetSnapGeometrySuccess',
  GetSnapGeometryError: '[application] GetSnapGeometryError',
  GetEditFeatureFields: '[application] GetEditFeatureFields',
  GetEditFeatureFieldsError: '[application] GetEditFeatureFieldsError',
  SetEditFeatureFields: '[application] SetEditFeatureFields',
  GetAppSettings: '[application] GetAppSettings',
  GetAppSettingsError: '[application] GetAppSettingsError',
  SetAppSettings: '[application] SetAppSettings',
  RefreshActiveLegends: '[application] RefreshActiveLegends',
  CheckRelatedTables: '[application] CheckRelatedTables',
  SetRelatedRecords: '[application] SetRelatedRecords',
  SetInspectionAttachments: '[application] SetInspectionAttachments',
  GetFeatureAttachments: '[application] GetFeatureAttachments',
  SetFeatureAttachments: '[application] SetFeatureAttachments',
  ShowThumbnails: '[application] ShowThumbnails',
  GetRelatedTables: '[application] GetRelatedTables',
  ConcatRelatedRecords: '[application] ConcatRelatedRecords',
  GetRelTblName: '[application] GetRelTblName',
  SetRelatedAttachments: '[application] SetRelatedAttachments',
  GetAttachment: '[application] GetAttachment',
  GetAttachments: '[application] GetAttachments',
  GetEditRequiredFields: '[application] GetEditRequiredFields',
  GetEditRequiredFieldsError: '[application] GetEditRequiredFieldsError',
  SetEditRequiredFields: '[application] SetEditRequiredFields',
  GetEditReadOnlyFields: '[application] GetEditReadOnlyFields',
  GetEditReadOnlyFieldsError: '[application] GetEditReadOnlyFieldsError',
  SetEditReadOnlyFields: '[application] SetEditReadOnlyFields',
  SetEditPermissionSymbology: '[application] SetEditPermissionSymbology',
  GetFlowWorksData: '[application] GetFlowWorksData',
  SetExternalFeature: '[application] SetExternalFeature',
  ToggleAlert: '[application] ToggleAlert',
  SearchPostingPlans: '[application] SearchPostingPlans',
  SearchPostingPlansByNum: '[application] SearchPostingPlansByNum',
  SetEditFeatureShowActiveLayer: '[application] SetEditFeatureShowActiveLayer',
  GetCoordsByAssetId: '[application] GetCoordsByAssetId',
  SearchAsset: '[application] SearchAsset',
  GetCAD: '[application] GetCAD',
  SetCAD: '[application] SetCAD',
  GetOutstandingED: '[application] GetOutstandingED',
  SetOutstandingED: '[application] SetOutstandingED',
  UpdateEngDraw: '[application] UpdateEngDraw',
  ExportInspections: '[application] ExportInspections',
  ShapeCreated: '[application] ShapeCreated',
  GetToolsPermissions: '[application] GetToolsPermissions',
  SetToolsPermissions: '[application] SetToolsPermissions',
  PopulationSelectMode: '[application] PopulationSelectMode',
  PopulationSelectedArea: '[application] PopulationSelectedArea',
  PopulationClearSelectedArea: '[application] PopulationClearSelectedArea',
  PopulationSetState: '[application] PopulationSetState',
  SetFromMeasureTool: '[application] SetFromMeasureTool',
  PopulationGetShape: '[application] PopulationGetShape',

};

export interface WindowSize {
  windowInnerHeight: number;
  windowInnerWidth: number;
}

export class DelayedAction implements Action {
  public type: string = ApplicationActionType.DelayedAction;

  constructor(public payload: Action[] = []) { }
}

export class DelayedActionBy1 implements Action {
  public type: string = ApplicationActionType.DelayedActionBy1;

  constructor(public payload: Action[] = []) { }
}

export class Search implements Action {
  public type: string = ApplicationActionType.Search;

  constructor(public payload: SearchPayload) { }
}

export class SearchSuccess implements Action {
  public type: string = ApplicationActionType.SearchSuccess;
  constructor(public payload: SearchPayload) { }
}

export class SearchError implements Action {
  public type: string = ApplicationActionType.SearchError;
  constructor(public payload: SearchPayload) { }
}

export class SearchReset implements Action {
  public type: string = ApplicationActionType.SearchReset;
  constructor(public payload: any = null) { }
}

export class Idle implements Action {
  public type: string = ApplicationActionType.Idle;

  constructor(public payload: any = null) { }
}

export class Draw implements Action {
  public type: string = ApplicationActionType.Draw;

  constructor(public payload: any = null) { }
}

export class Layer implements Action {
  public type: string = ApplicationActionType.Layer;

  constructor(public payload: any = null) { }
}

export class Legend implements Action {
  public type: string = ApplicationActionType.Legend;

  constructor(public payload: any = null) { }
}

export class Table implements Action {
  public type: string = ApplicationActionType.Table;

  constructor(public payload: any = null) { }
}

export class Toolbox implements Action {
  public type: string = ApplicationActionType.Toolbox;

  constructor(public payload: any = null) { }
}

export class Measure implements Action {
  public type: string = ApplicationActionType.Measure;

  constructor(public payload: any = null) { }
}

export class GetLayers implements Action {
  public type: string = ApplicationActionType.GetLayers;

  constructor(public payload: any = null) { }
}

export class CheckLayerDisplay implements Action {
  public type: string = ApplicationActionType.CheckLayerDisplay;

  constructor(public payload: any = null) { }
}

export class SetSearchCoordinates implements Action {
  public type: string = ApplicationActionType.SetSearchCoordinates;
  constructor(public payload: SearchCoordinatesPayload) { }
}

export class SearchCoordinates implements Action {
  public type: string = ApplicationActionType.SearchCoordinates;
  constructor(public payload: SearchCoordinatesPayload) { }
}

export class SearchCoordinatesSuccess implements Action {
  public type: string = ApplicationActionType.SearchCoordinatesSuccess;
  constructor(public payload: SearchCoordinatesPayload) { }
}

export class SearchCoordinatesError implements Action {
  public type: string = ApplicationActionType.SearchCoordinatesError;
  constructor(public payload: SearchCoordinatesPayload) { }
}

export class SearchFromCoordinates implements Action {
  public type: string = ApplicationActionType.SearchFromCoordinates;
  constructor(public payload: DnvMapInfo) { }
}

export class SearchFromCoordinatesSuccess implements Action {
  public type: string = ApplicationActionType.SearchFromCoordinatesSuccess;
  constructor(public payload: SearchCoordinatesPayload) { }
}

export class SearchFromCoordinatesError implements Action {
  public type: string = ApplicationActionType.SearchFromCoordinatesError;
  constructor(public payload: SearchFromCoordinatesErrorPayload) { }
}

export class GetShape implements Action {
  public type: string = ApplicationActionType.GetShape;
  constructor(public payload: string) { }
}

export class GetDBLink implements Action {
  public type: string = ApplicationActionType.GetDBLink;
  constructor(public payload: any) { }
}

export class GridSelectLayer implements Action {
  public type: string = ApplicationActionType.GridSelectLayer;
  constructor(public payload: GridSelectLayerPayload) { }
}

export class GetGridSelectLayerSuccess implements Action {
  public type: string = ApplicationActionType.GetGridSelectLayerSuccess;
  constructor(public payload: GridSelectLayerPayload) { }
}

export class InvalidateGridCache implements Action {
  public type: string = ApplicationActionType.InvalidateGridCache;
  constructor(public payload: GridSelectLayerPayload) { }
}

export class SetGridRasterHighlight implements Action {
  public type: string = ApplicationActionType.SetGridRasterHighlight;
  constructor(public payload: any) { }
}

export class GetGridSelectLayerError implements Action {
  public type: string = ApplicationActionType.GetGridSelectLayerError;
  constructor(public payload: GridSelectLayerPayload) { }
}

export class UpdateWindowSize implements Action {
  public type: string = ApplicationActionType.UpdateWindowSize;
  constructor(public payload: WindowSize = { windowInnerHeight: 0, windowInnerWidth: 0 }) { }
}

export class GetBasemaps implements Action {
  public type: string = ApplicationActionType.GetBasemaps;
  constructor(public payload: any = null) { }
}

export class GetMetaData implements Action {
  public type: string = ApplicationActionType.GetMetaData;
  constructor(public payload: string) { }
}

export class GetDataNames implements Action {
  public type: string = ApplicationActionType.GetDataNames;
  constructor(public payload: any = null) { }
}

export class ToastUserNotification implements Action {
  public type: string = ApplicationActionType.ToastUserNotification;
  constructor(public payload: UserNotification = null) { }
}

export class IdentifySurroundingFeature implements Action {
  public type: string = ApplicationActionType.IdentifySurroundingFeature;

  constructor(public payload: any) { }
}

export class IdentifySurroundingFeaturePost implements Action {
  public type: string = ApplicationActionType.IdentifySurroundingFeaturePost;

  constructor(public payload: any) { }
}

export class GetFeatureData implements Action {
  public type: string = ApplicationActionType.GetFeatureData;
  constructor(public payload: any) { }
}

export class SetSurroundingFeature implements Action {
  public type: string = ApplicationActionType.SetSurroundingFeature;
  constructor(public payload: boolean) { }
}

export class ConcatSelectedFeatureSections implements Action {
  public type: string = ApplicationActionType.ConcatSelectedFeatureSections;
  constructor(public payload: KvSection) { }
}

export class SetSelectedFeatureSections implements Action {
  public type: string = ApplicationActionType.SetSelectedFeatureSections;
  constructor(public payload: KvSection[]) { }
}

export class Export implements Action {
  public type: string = ApplicationActionType.Export;

  constructor(public payload: any = null) { }
}


export class AppMapViewLoadFinished implements Action {
  public type: string = ApplicationActionType.AppMapViewLoadFinished;

  constructor(public payload: Action[] = []) { }
}

export class SearchEngineerDrawings implements Action {
  public type: string = ApplicationActionType.SearchEngineerDrawings;

  constructor(public payload: DnvLatLng[] = []) { }
}

export class SearchEngineerDrawingsByNum implements Action {
  public type: string = ApplicationActionType.SearchEngineerDrawingsByNum;

  constructor(public payload: string = '') { }
}

export class SearchEngineerDrawingsByProj implements Action {
  public type: string = ApplicationActionType.SearchEngineerDrawingsByProj;

  constructor(public payload: string = '') { }
}

export class GetEngDrawingGeometry implements Action {
  public type: string = ApplicationActionType.GetEngDrawingGeometry;

  constructor(public payload: SearchedInfo) { }
}

export class OpenEngDrawing implements Action {
  public type: string = ApplicationActionType.OpenEngDrawing;

  constructor(public payload: string) { }
}

export class OpenMapView implements Action {
  public type: string = ApplicationActionType.OpenMapView;

  constructor(public payload: { route: any[], queryParams?: any }) { }
}

export class RenewArcGisToken implements Action {
  public type: string = ApplicationActionType.RenewArcGisToken;

  constructor(public payload: RenewArcGisTokenPayload) { }
}

export class RenewArcGisTokenSuccess implements Action {
  public type: string = ApplicationActionType.RenewArcGisTokenSuccess;

  constructor(public payload: RenewArcGisTokenPayload) { }
}

export class RenewArcGisTokenError implements Action {
  public type: string = ApplicationActionType.RenewArcGisTokenError;

  constructor(public payload: RenewArcGisTokenPayload) { }
}

// export class CCTV implements Action {
//   public type: string = ApplicationActionType.CCTV;

//   constructor(public payload: any = null) { }
// }

export class SearchCCTV implements Action {
  public type: string = ApplicationActionType.SearchCCTV;

  constructor(public payload: string) { }
}

export class SetCCTV implements Action {
  public type: string = ApplicationActionType.SetCCTV;

  constructor(public payload: any) { }
}

export class SelectCCTV implements Action {
  public type: string = ApplicationActionType.SelectCCTV;

  constructor(public payload: any) { }
}

export class SearchCCTVNotes implements Action {
  public type: string = ApplicationActionType.SearchCCTVNotes;

  constructor(public payload: string) { }
}

export class SetCCTVNotes implements Action {
  public type: string = ApplicationActionType.SetCCTVNotes;

  constructor(public payload: any) { }
}

export class SearchEngineerDrawingsByNumType implements Action {
  public type: string = ApplicationActionType.SearchEngineerDrawingsByNumType;

  constructor(public payload: { drawNum: string, drawType: string }) { }
}

export class SetToolboxStatus implements Action {
  public type: string = ApplicationActionType.SetToolboxStatus;

  constructor(public payload: any = null) { }
}

export class GetMailMergeByProperty implements Action {
  public type: string = ApplicationActionType.GetMailMergeByProperty;

  constructor(public payload: any = null) { }
}

export class GetMailMergeByArea implements Action {
  public type: string = ApplicationActionType.GetMailMergeByArea;

  constructor(public payload: any = null) { }
}

export class GetMailMergeList implements Action {
  public type: string = ApplicationActionType.GetMailMergeList;

  constructor(public payload: any = null) { }
}

//ToolboxMailMerge

export class ToolboxMailMerge implements Action {
  public type: string = ApplicationActionType.ToolboxMailMerge;

  constructor(public payload: ToolboxMailMergePayload = null) { }
}

export class ToolboxMailMergeArea implements Action {
  public type: string = ApplicationActionType.ToolboxMailMergeArea;

  constructor(public payload: any = null) { } // this payload is a geometry
}

export class ToolboxMailMergeBuffer implements Action {
  public type: string = ApplicationActionType.ToolboxMailMergeBuffer;

  constructor(public payload: any = null) { } // this payload is a geometry
}

export class ToolboxMailMergeSelectedParcels implements Action {
  public type: string = ApplicationActionType.ToolboxMailMergeSelectedParcels;

  constructor(public payload: any[] = null) { } // this payload is a geometry
}

export class ToolboxMailMergeToggleParcelAtCoordinate implements Action {
  public type: string = ApplicationActionType.ToolboxMailMergeToggleParcelAtCoordinate;

  constructor(public payload: any = null) { } // this payload is a geometry
}

export class ToolboxMailMergeToggleParcel implements Action {
  public type: string = ApplicationActionType.ToolboxMailMergeToggleParcel;

  constructor(public payload: any = null) { } // this payload is a geometry
}

export class ToolboxMailMergeUpdateOptions implements Action {
  public type: string = ApplicationActionType.ToolboxMailMergeUpdateOptions;

  constructor(public payload: ToolboxMailMergeOptions = null) { } // this payload is a geometry
}

export class ToolboxMailMergeUpdateResultCount implements Action {
  public type: string = ApplicationActionType.ToolboxMailMergeUpdateResultCount;

  constructor(public payload: { links: string[], toOwners: boolean, toOccupants: boolean, preferOwnerName: boolean, groupOwners: boolean } = null) { }
}

export class ToolboxMailMergeUpdateResultCountSuccess implements Action {
  public type: string = ApplicationActionType.ToolboxMailMergeUpdateResultCountSuccess;

  constructor(public payload: any = null) { } // this payload is a geometry
}

export class RefreshDisplayedGeoJson implements Action {
  public type: string = ApplicationActionType.RefreshDisplayedGeoJson;

  constructor(public payload: any = null) { }
}

export class SetMailMergeList implements Action {
  public type: string = ApplicationActionType.SetMailMergeList;

  constructor(public payload: any = null) { }
}

export class SetMailMergeDBLinks implements Action {
  public type: string = ApplicationActionType.SetMailMergeDBLinks;

  constructor(public payload: any = null) { }
}

export class LaunchStreetView implements Action {
  public type: string = ApplicationActionType.LaunchStreetView;

  constructor(public payload: any = null) { }
}

export class ToggleStreetView implements Action {
  public type: string = ApplicationActionType.ToggleStreetView;

  constructor(public payload: any = null) { }
}

export class SetMeasurements implements Action {
  public type: string = ApplicationActionType.SetMeasurements;

  constructor(public payload: any = null) { }
}

export class SetFeatureRasterHighlight implements Action {
  public type: string = ApplicationActionType.SetFeatureRasterHighlight;
  constructor(public payload: any) { }
}

export class GetCoordsByObjectId implements Action {
  public type: string = ApplicationActionType.GetCoordsByObjectId;
  constructor(public payload: any) { }
}

export class GetCoordsByAssetId implements Action {
  public type: string = ApplicationActionType.GetCoordsByAssetId;
  constructor(public payload: any) { }
}

export class SetEditFeature implements Action {
  public type: string = ApplicationActionType.SetEditFeature;
  constructor(public payload: any) { }
}

export class GetEditPermission implements Action {
  public type: string = ApplicationActionType.GetEditPermission;
  constructor(public payload: any = null) { }
}

export class SetEditPermission implements Action {
  public type: string = ApplicationActionType.SetEditPermission;
  constructor(public payload: any) { }
}

export class SetNewFeatureLatLng implements Action {
  public type: string = ApplicationActionType.SetNewFeatureLatLng;
  constructor(public payload: DnvLatLng[] = null) { }
}

export class SetLastEditFeature implements Action {
  public type: string = ApplicationActionType.SetLastEditFeature;
  constructor(public payload: number) { }
}

export class SaveEditFeature implements Action {
  public type: string = ApplicationActionType.SaveEditFeature;
  constructor(public payload: any) { }
}

export class DeleteEditFeature implements Action {
  public type: string = ApplicationActionType.DeleteEditFeature;
  constructor(public payload: any) { }
}

export class UpdateEditFeature implements Action {
  public type: string = ApplicationActionType.UpdateEditFeature;
  constructor(public payload: any) { }
}

export class GetMaxAssetId implements Action {
  public type: string = ApplicationActionType.GetMaxAssetId;
  constructor(public payload: any) { }
}

export class GetMaxAssetIdError implements Action {
  public type: string = ApplicationActionType.GetMaxAssetIdError;
  constructor(public payload: any) { }
}

export class SetMaxAssetId implements Action {
  public type: string = ApplicationActionType.SetMaxAssetId;
  constructor(public payload: any) { }
}

export class UpdateEditFeatureGeometry implements Action {
  public type: string = ApplicationActionType.UpdateEditFeatureGeometry;
  constructor(public payload: any) { }
}

export class SetShowSpinner implements Action {
  public type: string = ApplicationActionType.SetShowSpinner;
  constructor(public payload: boolean) { }
}

export class SetShowSearchSpinner implements Action {
  public type: string = ApplicationActionType.SetShowSearchSpinner;
  constructor(public payload: boolean) { }
}

export class SetUserProfile implements Action {
  public type: string = ApplicationActionType.SetUserProfile;
  constructor(public payload: UserProfile) { }
}

export class GetSnapGeometry implements Action {
  public type: string = ApplicationActionType.GetSnapGeometry;
  constructor(public payload: any) { }
}

export class GetSnapGeometrySuccess implements Action {
  public type: string = ApplicationActionType.GetSnapGeometrySuccess;
  constructor(public payload: any) { }
}

export class GetSnapGeometryError implements Action {
  public type: string = ApplicationActionType.GetSnapGeometryError;
  constructor(public payload: any) { }
}

export class GetEditFeatureFields implements Action {
  public type: string = ApplicationActionType.GetEditFeatureFields;
  constructor(public payload: string) { }
}

export class GetEditFeatureFieldsError implements Action {
  public type: string = ApplicationActionType.GetEditFeatureFieldsError;
  constructor(public payload: string) { }
}

export class SetEditFeatureFields implements Action {
  public type: string = ApplicationActionType.SetEditFeatureFields;
  constructor(public payload: any) { }
}

export class GetAppSettings implements Action {
  public type: string = ApplicationActionType.GetAppSettings;
  constructor(public payload: any = null) { }
}

export class GetAppSettingsError implements Action {
  public type: string = ApplicationActionType.GetAppSettingsError;
  constructor(public payload: any) { }
}

export class SetAppSettings implements Action {
  public type: string = ApplicationActionType.SetAppSettings;
  constructor(public payload: any) { }
}

export class RefreshActiveLegends implements Action {
  public type: string = ApplicationActionType.RefreshActiveLegends;
  constructor(public payload: any = null) { }
}

export class CheckRelatedTables implements Action {
  public type: string = ApplicationActionType.CheckRelatedTables;
  constructor(public payload: any = null) { }
}

export class SetRelatedRecords implements Action {
  public type: string = ApplicationActionType.SetRelatedRecords;
  constructor(public payload: any = null) { }
}

export class SetInspectionAttachments implements Action {
  public type: string = ApplicationActionType.SetInspectionAttachments;
  constructor(public payload: any = null) { }
}

export class GetFeatureAttachments implements Action {
  public type: string = ApplicationActionType.GetFeatureAttachments;
  constructor(public payload: any = null) { }
}

export class SetFeatureAttachments implements Action {
  public type: string = ApplicationActionType.SetFeatureAttachments;
  constructor(public payload: any = null) { }
}

export class ShowThumbnails implements Action {
  public type: string = ApplicationActionType.ShowThumbnails;
  constructor(public payload: any = null) { }
}

export class GetRelatedTables implements Action {
  public type: string = ApplicationActionType.GetRelatedTables;
  constructor(public payload: any = null) { }
}

export class GetAttachment implements Action {
  public type: string = ApplicationActionType.GetAttachment;
  constructor(public payload: any = null) { }
}

export class GetAttachments implements Action {
  public type: string = ApplicationActionType.GetAttachments;
  constructor(public payload: any = null) { }
}

export class ConcatRelatedRecords implements Action {
  public type: string = ApplicationActionType.ConcatRelatedRecords;
  constructor(public payload: any = null) { }
}

export class GetRelTblName implements Action {
  public type: string = ApplicationActionType.GetRelTblName;
  constructor(public payload: any = null) { }
}

export class SetRelatedAttachments implements Action {
  public type: string = ApplicationActionType.SetRelatedAttachments;
  constructor(public payload: any = null) { }
}

export class GetEditRequiredFields implements Action {
  public type: string = ApplicationActionType.GetEditRequiredFields;
  constructor(public payload: any = null) { }
}

export class GetEditRequiredFieldsError implements Action {
  public type: string = ApplicationActionType.GetEditRequiredFieldsError;
  constructor(public payload: string) { }
}

export class SetEditRequiredFields implements Action {
  public type: string = ApplicationActionType.SetEditRequiredFields;
  constructor(public payload: any) { }
}

export class GetEditReadOnlyFields implements Action {
  public type: string = ApplicationActionType.GetEditReadOnlyFields;
  constructor(public payload: any = null) { }
}

export class GetEditReadOnlyFieldsError implements Action {
  public type: string = ApplicationActionType.GetEditReadOnlyFieldsError;
  constructor(public payload: string) { }
}

export class SetEditReadOnlyFields implements Action {
  public type: string = ApplicationActionType.SetEditReadOnlyFields;
  constructor(public payload: any) { }
}

export class SetEditPermissionSymbology implements Action {
  public type: string = ApplicationActionType.SetEditPermissionSymbology;
  constructor(public payload: any) { }
}


export class GetFlowWorksData implements Action {
  public type: string = ApplicationActionType.GetFlowWorksData;

  constructor(public payload: string) { }
}

export class SetExternalFeature implements Action {
  public type: string = ApplicationActionType.SetExternalFeature;
  constructor(public payload: any) { }
}

export class ToggleAlert implements Action {
  public type: string = ApplicationActionType.ToggleAlert;
  constructor(public payload: boolean = null) { }
}

export class SearchPostingPlans implements Action {
  public type: string = ApplicationActionType.SearchPostingPlans;

  constructor(public payload: DnvLatLng[] = []) { }
}

export class SearchPostingPlansByNum implements Action {
  public type: string = ApplicationActionType.SearchPostingPlansByNum;

  constructor(public payload: string = '') { }
}

export class SetEditFeatureShowActiveLayer implements Action {
  public type: string = ApplicationActionType.SetEditFeatureShowActiveLayer;

  constructor(public payload: boolean) { }
}

export class SearchAsset implements Action {
  public type: string = ApplicationActionType.SearchAsset;

  constructor(public payload: any) { }
}

export class GetCAD implements Action {
  public type: string = ApplicationActionType.GetCAD;

  constructor(public payload: any = null) { }
}

export class SetCAD implements Action {
  public type: string = ApplicationActionType.SetCAD;

  constructor(public payload: any) { }
}

export class GetOutstandingED implements Action {
  public type: string = ApplicationActionType.GetOutstandingED;

  constructor(public payload: any = null) { }
}

export class SetOutstandingED implements Action {
  public type: string = ApplicationActionType.SetOutstandingED;

  constructor(public payload: any) { }
}

export class UpdateEngDraw implements Action {
  public type: string = ApplicationActionType.UpdateEngDraw;

  constructor(public payload: any) { }
}

export class ExportInspections implements Action {
  public type: string = ApplicationActionType.ExportInspections;

  constructor(public payload: any = null) { }
}

export class ShapeCreated implements Action {
  public type: string = ApplicationActionType.ShapeCreated;

  constructor(public payload: any = null) { }
}

export class GetToolsPermissions
  implements Action {
  public type: string = ApplicationActionType.GetToolsPermissions;

  constructor(public payload: any = null) { }
}

export class SetToolsPermissions
  implements Action {
  public type: string = ApplicationActionType.SetToolsPermissions;

  constructor(public payload: any = null) { }
}

export class PopulationSelectMode
  implements Action {
  public type: string = ApplicationActionType.PopulationSelectMode;

  constructor(public payload: string) { }
}

export class PopulationSelectedArea
  implements Action {
  public type: string = ApplicationActionType.PopulationSelectedArea;

  constructor(public payload: any = null) { }
}

export class PopulationClearSelectedArea
  implements Action {
  public type: string = ApplicationActionType.PopulationClearSelectedArea;

  constructor(public payload: any = null) { }
}

export class PopulationSetState
  implements Action {
  public type: string = ApplicationActionType.PopulationSetState;

  constructor(public payload: any = null) { }
}

export class SetFromMeasureTool
  implements Action {
  public type: string = ApplicationActionType.SetFromMeasureTool;

  constructor(public payload: any = null) { }
}

export class PopulationGetShape
  implements Action {
  public type: string = ApplicationActionType.PopulationGetShape;

  constructor(public payload: any = null) { }
}



export type ApplicationAction =
  DelayedAction |
  DelayedActionBy1 |
  Idle |
  Layer |
  Search |
  Legend |
  Toolbox |
  Draw |
  Measure |
  Table |
  GetLayers |
  CheckLayerDisplay |
  SetSearchCoordinates |
  SearchCoordinates |
  SearchCoordinatesSuccess |
  SearchCoordinatesError |
  SearchFromCoordinates |
  SearchFromCoordinatesSuccess |
  SearchFromCoordinatesError |
  GetShape |
  GetDBLink |
  GridSelectLayer |
  GetGridSelectLayerSuccess |
  GetGridSelectLayerError |
  InvalidateGridCache |
  SetGridRasterHighlight |
  UpdateWindowSize |
  GetBasemaps |
  GetMetaData |
  GetDataNames |
  ToastUserNotification |
  IdentifySurroundingFeature |
  IdentifySurroundingFeaturePost |
  GetFeatureData |
  SetSurroundingFeature |
  SetSelectedFeatureSections |
  ConcatSelectedFeatureSections |
  Export |
  // EngDraw |
  AppMapViewLoadFinished |
  SearchEngineerDrawings |
  SearchEngineerDrawingsByNum |
  SearchEngineerDrawingsByProj |
  SearchEngineerDrawingsByNumType |
  GetEngDrawingGeometry |
  OpenEngDrawing |
  OpenMapView |
  RenewArcGisToken |
  RenewArcGisTokenSuccess |
  RenewArcGisTokenError |
  //  CCTV |
  SearchCCTV |
  SetCCTV |
  SelectCCTV |
  SearchCCTVNotes |
  SetCCTVNotes |
  //  PropInfo
  SetToolboxStatus |
  GetMailMergeByProperty |
  GetMailMergeByArea |
  GetMailMergeList |
  ToolboxMailMerge |
  ToolboxMailMergeArea |
  ToolboxMailMergeBuffer |
  ToolboxMailMergeSelectedParcels |
  ToolboxMailMergeToggleParcelAtCoordinate |
  ToolboxMailMergeToggleParcel |
  ToolboxMailMergeUpdateOptions |
  ToolboxMailMergeUpdateResultCount |
  ToolboxMailMergeUpdateResultCountSuccess |
  RefreshDisplayedGeoJson |
  SetMailMergeList |
  SetMailMergeDBLinks |
  LaunchStreetView |
  ToggleStreetView |
  SetMeasurements |
  SetFeatureRasterHighlight |
  GetCoordsByObjectId |
  GetCoordsByAssetId |
  SetEditFeature |
  GetEditPermission |
  SetEditPermission |
  SetNewFeatureLatLng |
  SetLastEditFeature |
  SaveEditFeature |
  UpdateEditFeature |
  DeleteEditFeature |
  GetMaxAssetId |
  GetMaxAssetIdError |
  SetMaxAssetId |
  UpdateEditFeatureGeometry |
  SetShowSpinner |
  SetShowSearchSpinner |
  SetUserProfile |
  GetSnapGeometry |
  GetSnapGeometrySuccess |
  GetSnapGeometryError |
  GetEditFeatureFields |
  GetEditFeatureFieldsError |
  SetEditFeatureFields |
  GetAppSettings |
  GetAppSettingsError |
  SetAppSettings |
  RefreshActiveLegends |
  CheckRelatedTables |
  SetRelatedRecords |
  SetInspectionAttachments |
  GetFeatureAttachments |
  SetFeatureAttachments |
  ShowThumbnails |
  GetRelatedTables |
  GetAttachment |
  GetAttachments |
  ConcatRelatedRecords |
  GetRelTblName |
  SetRelatedAttachments |
  GetEditRequiredFields |
  GetEditRequiredFieldsError |
  SetEditRequiredFields |
  GetEditReadOnlyFields |
  GetEditReadOnlyFieldsError |
  SetEditReadOnlyFields |
  SetEditPermissionSymbology |
  GetFlowWorksData |
  SetExternalFeature |
  ToggleAlert |
  SearchPostingPlans |
  SearchPostingPlansByNum |
  SetEditFeatureShowActiveLayer |
  SearchAsset |
  GetCAD |
  SetCAD |
  GetOutstandingED |
  SetOutstandingED |
  UpdateEngDraw |
  ExportInspections |
  ShapeCreated |
  GetToolsPermissions |
  SetToolsPermissions |
  PopulationSelectMode |
  PopulationSelectedArea |
  PopulationClearSelectedArea |
  PopulationSetState |
  SetFromMeasureTool |
  PopulationGetShape
  ;
